import { render } from "./PageColumnWithUserEditor.vue?vue&type=template&id=3919aeb4&ts=true&lang=pug"
import script from "./PageColumnWithUserEditor.vue?vue&type=script&lang=ts"
export * from "./PageColumnWithUserEditor.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\ZiegFreeze\\Documents\\Work\\upa-fast-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__